import {useTabState} from "../index";

const TabHeader = ({children}) => {
    const state = useTabState()
    return state.layout.header(children)
}

export default TabHeader